import { render } from "./RechercheComponent.vue?vue&type=template&id=d8c752ec"
import script from "./RechercheComponent.vue?vue&type=script&lang=js"
export * from "./RechercheComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__